// @flow
import React, { Component } from 'react'

import LineChart from '../linechart'

import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/divider.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/label.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/message.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/loader.css'
import { hot } from 'react-hot-loader'
import './styles.scss'

type State = {
  zurichData: string[],
  berneData: string[],
  baselData: string[],
  dataReady: boolean
}

class AppComponent extends Component<State> {
  constructor (props) {
    super(props)
    this.state = {
      dataReady: false,
      zurichData: [],
      baselData: [],
      berneData: []
    }
  }

  componentWillMount () {
    fetch('https://interaktiv.tagesanzeiger.ch/2018/neujahr-feinstaub/fetchZurich.php')
      .then(response => response.json())
      .then(data1 => this.setState({
        zurichData: data1
      }))
      .then(
        fetch('https://interaktiv.tagesanzeiger.ch/2018/neujahr-feinstaub/fetchBasel.php')
          .then(response => response.json())
          .then(data2 => this.setState({
            baselData: data2
          }))
          .then(
            fetch('https://interaktiv.tagesanzeiger.ch/2018/neujahr-feinstaub/fetchBerne.php')
              .then(response => response.json())
              .then(data3 => this.setState({
                berneData: data3,
              }))
          ).then(() => this.setState({dataReady: true}))
      )
  }

  render () {
    return (
      <div className='index'>
        <div className={'ui message intro'}>
          <p><span style={{fontSize: '80%'}}>🚀</span>Feuerwerkskörper verschmutzen die Luft. Wir vergleichen über die Feiertage fortlaufend die Stundenwerte in <strong>Basel, Bern und Zürich.</strong></p>
        </div>
        {this.state.dataReady &&
        <div>
          {this.state.zurichData.length >
          0 &&
          this.state.berneData.length >
          0 &&
          this.state.baselData.length >
          0 &&
          <div className={'ui segment'}>
            <LineChart
              data={{
                zurich: this.state.zurichData,
                berne: this.state.berneData,
                basel: this.state.baselData
              }}
            />
          </div>
          }
          <div className={'ui small message'}>
            <p style={{textAlign: 'left'}}>Die Daten werden stündlich automatisch aktualisiert und stammen von den folgenden drei Messstationen:</p>
            <p className={'source label'}>
              <a href={'https://www.google.com/maps/place/Morgartenstrasse,+3014+Bern/@46.9638256,7.4583679,17z/data=!3m1!4b1!4m5!3m4!1s0x478e39faefc23881:0x8db85d92be235013!8m2!3d46.9638256!4d7.4605566'}
                 target={'_blank'}>
                <i className={'icon map'} />Morgartenstrasse, Bern
              </a>
            </p>
            <p className={'source label'}>
              <a href={'https://www.google.com/maps/place/St.+Johanns-Platz,+4056+Basel/@47.5665453,7.5795382,17z/data=!3m1!4b1!4m5!3m4!1s0x4791b909e7571c01:0x1fd393951c05ed5d!8m2!3d47.5665417!4d7.5817269'}
                 target={'_blank'}>
                <i className={'icon map'} />St. Johanns-Platz, Basel
              </a>
            </p>
            <p className={'source label'}>
              <a href={'https://www.google.com/maps?q=stampfenbachplatz&um=1&ie=UTF-8&sa=X&ved=0ahUKEwjVxPPvqsLfAhUKfFAKHaBPBUUQ_AUIDigB'}
                 target={'_blank'}>
                <i className={'icon map'} />Stampfenbachplatz, Zürich
              </a>
            </p>
          </div>
        </div>
        }
      </div>
    )
  }
}

export default hot(module)(AppComponent)
